import React from 'react'
import { Link } from 'react-router-dom'
import team from '../../assets/images/home_page_4/team/01.png'

const TeamDetails = () => {
    return (
        <>
            <section id="team-detail" className="team-detail-main-block">
                <div className="container">
                    <div className="team-detail-block">
                        <div className="row">
                            <div className="col-lg-6">
                                <img
                                    src={team}
                                    alt=""
                                    className="img-fluid"
                                />
                            </div>
                            <div className="col-lg-6">
                                <div className="team-dtls-one">
                                    <Link to="#" title="">
                                        <h3 className="team-dtl-name">Esther Howard</h3>
                                    </Link>
                                    <p>Human Resource</p>
                                    <p className="team-des">
                                        sed ut perspiciatis unde omnis iste natus error sit voluptatem
                                        accusantium doloremque laudantium, totam rem aperiam
                                    </p>
                                    <div className="team-contact-info">
                                        <div className="row mb_26">
                                            <div className="col-lg-3">
                                                <div className="team-contact-title">Phone :</div>
                                            </div>
                                            <div className="col-lg-9">
                                                <div className="team-contact-dtl">
                                                    <Link to="tel:+1234567890" title="">
                                                        +1234567890
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb_26">
                                            <div className="col-lg-3">
                                                <div className="team-contact-title">Email :</div>
                                            </div>
                                            <div className="col-lg-9">
                                                <div className="team-contact-dtl">
                                                    <Link to="mailto:nathan.roberts@example.com" title="">
                                                        nathan.roberts@example.com
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb_26">
                                            <div className="col-lg-3">
                                                <div className="team-contact-title">Website :</div>
                                            </div>
                                            <div className="col-lg-9">
                                                <div className="team-contact-dtl">
                                                    http://yoursite.com/mugli
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-3">
                                                <div className="team-contact-title">Address :</div>
                                            </div>
                                            <div className="col-lg-9">
                                                <div className="team-contact-dtl">
                                                    8502 Preston Rd. Inglewood, Maine 98380
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <ul className="team-social-icon">
                                        <li className="facebook">
                                            <Link to="" title="">
                                                <i className="flaticon-facebook" />
                                            </Link>
                                        </li>
                                        <li className="twitter">
                                            <Link to="" title="">
                                                <i className="flaticon-twitter" />
                                            </Link>
                                        </li>
                                        <li className="google-plus">
                                            <Link to="" title="">
                                                <i className="flaticon-google-plus" />
                                            </Link>
                                        </li>
                                        <li className="instagram">
                                            <Link to="" title="">
                                                <i className="flaticon-instagram" />
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="team-details-about">
                            <h2>About Me</h2>
                            <p>
                                Lorem ipsum, dolor sit amet consectetur adipisicing elit. Placeat
                                aspernatur, sequi eligendi aut saepe, cum adipisci neque quas minima
                                nisi possimus, atque explicabo harum! Voluptatem itaque, similique
                                adipisci officiis eius mollitia repellendus asperiores ipsum nostrum
                                quae consequuntur voluptates. Optio, Lorem ipsum dolor sit amet
                                consectetur adipisicing elit. Modi quia fuga eaque iusto ipsam quam
                                ipsum adipisci tempora porro non magnam quas ducimus ad, animi
                                aliquam, sed obcaecati dolore pariatur. Nihil autem incidunt maiores
                                nostrum.
                            </p>
                        </div>
                        <div className="team-details-about">
                            <h2>Skills</h2>
                            <p>
                                Lorem ipsum dolor sit amet consectetur adipisicing elit. Modi quia
                                fuga eaque iusto ipsam quam ipsum adipisci tempora porro non magnam
                                quas ducimus ad, animi aliquam, sed obcaecati dolore pariatur. Nihil
                                autem incidunt maiores nostrum. Repudiandae labore dolore vero
                                quisquam exercitationem fugit optio natus, ullam excepturi? Mollitia
                                delectus rem odio.
                            </p>
                            <div className="team-skills-progress-block">
                                <div className="row">
                                    <div className="col-lg-6 mb_26">
                                        <div className="row">
                                            <div className="col-lg-8">
                                                <h4 className="skill-progress-title">
                                                    The Walt Disney Company
                                                </h4>
                                            </div>
                                            <div className="col-lg-4">
                                                <div className="skill-progress-per text-end">45%</div>
                                            </div>
                                        </div>
                                        <div className="progress-block">
                                            <progress className="progress-bar" value={45} max={100} />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 mb_26">
                                        <div className="row">
                                            <div className="col-lg-8">
                                                <h4 className="skill-progress-title">
                                                    The Walt Disney Company
                                                </h4>
                                            </div>
                                            <div className="col-lg-4">
                                                <div className="skill-progress-per text-end">45%</div>
                                            </div>
                                        </div>
                                        <div className="progress-block">
                                            <progress className="progress-bar" value={45} max={100} />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 mb_26">
                                        <div className="row">
                                            <div className="col-lg-8">
                                                <h4 className="skill-progress-title">Louis Vuitton</h4>
                                            </div>
                                            <div className="col-lg-4">
                                                <div className="skill-progress-per text-end">80%</div>
                                            </div>
                                        </div>
                                        <div className="progress-block">
                                            <progress className="progress-bar" value={80} max={100} />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 mb_26">
                                        <div className="row">
                                            <div className="col-lg-8">
                                                <h4 className="skill-progress-title">Louis Vuitton</h4>
                                            </div>
                                            <div className="col-lg-4">
                                                <div className="skill-progress-per text-end">80%</div>
                                            </div>
                                        </div>
                                        <div className="progress-block">
                                            <progress className="progress-bar" value={80} max={100} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default TeamDetails
